import Tippy from "@tippyjs/react";
import "css/tooltip.css";

export default function Tooltip({ content, labelText, placement }) {
  return (
    <Tippy
      content={<p className="text-theme-text-primary">{content}</p>}
      placement={placement}
      offset={[0, 4]}
      className="tippy-textbox"
      trigger="click"
      popperOptions={{
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["bottom", "top"],
            },
          },
        ],
      }}
    >
      <div className="relative inline-block underline cursor-pointer text-ui-blue">
        {labelText}
      </div>
    </Tippy>
  );
}
